import * as Yup from 'yup';
export const validationSchema = Yup.object({
    departure: Yup.object({
        label: Yup.string().required('Por favor, selecione um local de origem'),
    }).required('Campo obrigatório'),
    destination: Yup.object({
        label: Yup.string().required('Por favor, selecione um local de destino'),
    }).required('Campo obrigatório'),
    dateRange: Yup.array()
        .of(Yup.date().nullable())
        .required('Campo obrigatório')
        .test('is-not-null', 'Por favor, selecione uma data de check-in e check-out', value => Array.isArray(value) && value.length === 2 && value.every(date => date !== null)),
    adults: Yup.number().min(1, 'Pelo menos 1 adulto é necessário').max(4, 'Não pode mais de 4 adultos').required(),
    children: Yup.number().min(0).max(3, 'Não pode mais de 3 crianças').required(),
    qntRoom: Yup.array().min(1, 'Você precisa de pelo menos 1 quarto').required(),
});
//# sourceMappingURL=Validations.js.map